var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea70e39ca4f9cbb3ee6d2fab663fe4bb.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    